import { useOffline } from '../components/App/AppOfflineContext';
import MainLayout, { useMainLayoutContext } from '../components/MainLayout';
import Tile from '../shared/components/EqxTile/EqxTile';
import TileGroup from '../shared/components/EqxTile/EqxTileGroup';

interface PageDocsProps { }
const PageDocs = function (props: PageDocsProps) {
    return (
        <MainLayout pageTitle="Docs">
            <DocsContent />
        </MainLayout>
    )
}

const DocsContent = () => {
    const { isOffline, isFileCached } = useOffline();
    const mainContext = useMainLayoutContext()
    const disabledControlledDocs = isOffline && !isFileCached('/controlled-documents');
    const disabledForms = (isOffline && !isFileCached('/continuum-forms')) || !mainContext.permissions?.canViewContinuumForms;

    return (
        <TileGroup size="xs">
            <Tile
                className="col-6 col-lg-4"
                link="/controlled-documents"
                title="Controlled Documents"
                icon="fas fa-file-contract"
                disabled={disabledControlledDocs}
            />
            <Tile
                className="col-6 col-lg-4"
                link="/forms"
                title="Forms"
                icon="tile-icon fas fa-file-alt"
                disabled={disabledForms}
            />
        </TileGroup>
    )
}

export { PageDocs as default };


